const zhTranslation = {
    "login": "登录",
    "login_failed": "登录失败",
    "email": "电子邮件",
    "password": "密码",
    "create_account": "创建账户",
    "forgot_password": "忘记密码",
    "reset_password": "重置密码",
    "reset_password_error": "重置密码错误",
    "send_reset_link": "发送重置链接",
    "reset_token": "重置令牌",
    "new_password": "新密码",
    "registration_failed": "注册失败",
    "sign_up": "注册",
    "username": "用户名",
    "settings": "设置",
    "general": "常规",
    "avatar": "头像",
    "dark_mode": "深色模式",
    "language": "语言",
    "unblock_posts": "取消屏蔽帖子",
    "advanced": "高级",
    "delete_account": "删除账户",
    "delete": "删除",
    "change_avatar": "更改头像",
    "enter_new_username": "输入您的新用户名：",
    "enter_new_email": "输入您的新电子邮件：",
    "enter_new_password": "输入您的新密码：",
    "select_language": "选择语言",
    "back": "返回",
    "change": "更改",
    "no_blocked_posts": "没有被屏蔽的帖子。",
    "unblock": "取消屏蔽",
    "enter_password_to_delete": "输入当前密码以删除您的账户：",
    "all": "全部",
    "friends": "朋友",
    "favorite_games": "喜欢的游戏",
    "games": "游戏",
    "more_badges": "更多徽章",
    "no_in_progress_badges": "没有进行中的徽章",
    "all_earned_badges": "所有已获得的徽章",
    "close": "关闭",
    "style_guide": "风格指南",
    "accept": "接受",
    "reject": "拒绝",
    "search_website": "搜索全站",
    "go": "GO!",
    "create+": "创建 +",
    "profile": "个人资料",
    "logout": "登出",
    "about_us": "关于我们",
    "notifications": "通知",
    "friend_requests": "好友请求",
    "badges": "徽章",
    "no_new_requests": "没有新的请求",
    "no_new_badge_alerts": "没有新的徽章提醒",
    "post_type": "帖子类型",
    "other": "其他",
    "clear": "清除",
    "genre": "类型",
    "go_to_page": "前往页面",
    "loading_posts": "加载帖子中...",
    "loading_friends": "加载好友中...",
    "no_posts_yet": "还没有人发帖，快抢沙发！",
    "loading_more_posts": "加载更多帖子中...",
    "search_results_for": "搜索结果：",
    "no_posts_found": "未找到帖子。",
    "post_not_found": "未找到帖子",
    "post_blocked": "此帖子已被屏蔽。",
    "no_users_found": "未找到用户。",
    "no_games_found": "未找到游戏。",
    "view_profile": "查看资料",
    "trending_games": "热门游戏",
    "my_connections": "我的好友",
    "no_connections_found": "未找到好友，请尝试发送好友请求。",
    "connection_already_exists": "连接已存在或正在等待中。",
    "error_sending_request": "发送请求时出错。",
    "find_a_friend": "寻找好友！",
    "connect": "添加",
    "cancel": "取消",
    "message": "消息",
    "block": "屏蔽",
    "unfriend": "删除",
    "rejected": "已拒绝",
    "canceled": "已取消",
    "please_log_in": "请登录...",
    "loading": "加载中...",
    "visibility": "可见性",
    "friends_only": "仅好友",
    "public": "公开",
    "save": "保存",
    "edited": "已编辑",
    "no_choices_available": "没有可用的选项",
    "comments": "评论",
    "block_post_confirmation": "您确定要屏蔽此帖子吗？",
    "yes": "是",
    "no": "否",
    "edit": "编辑",
    "edit_poll_choices": "编辑投票选项：",
    "remove": "移除",
    "add_choice": "添加选项",
    "comment": "评论",
    "submit": "提交",
    "post": "帖子",
    "poll": "投票",
    "create_post": "发布帖子",
    "title": "标题",
    "title_placeholder": "输入帖子标题...",
    "game": "游戏",
    "search_game_placeholder": "搜索游戏...",
    "no_results_found": "未找到结果",
    "body": "内容",
    "body_placeholder": "输入您的帖子内容...",
    "tags": "标签",
    "hide_tags": "隐藏标签",
    "select_tags": "选择标签",
    "title_body_empty_error": "标题和内容不能为空。",
    "post_creation_error": "创建帖子时出错！请再试一次。",
    "create": "发布",
    "create_poll": "发起投票",
    "poll_duration": "投票时长",
    "poll_options": "投票选项",
    "add_option": "添加选项",
    "posts": "帖子",
    "users": "用户",
    "view_all_filters": "查看所有筛选",
    "profile_image_alt": "头像",
    "bio_placeholder": "输入您的签名！",
    "name": "名字",
    "overview": "概览",
    "see_more": "查看更多",
    "add_friend": "添加好友",
    "untitled_post": "无标题帖子",
    "unknown_date": "未知日期",
    "loading_profile": "加载个人资料中...",
    "completed": "已完成",
    "in_progress": "进行中",
    "badge_tiers": "徽章等级",
    "rookie": "新手",
    "bronze": "青铜",
    "silver": "白银",
    "gold": "黄金",
    "platinum": "铂金",
    "earned": "已获得",
    "favorite_games_saved": "喜欢的游戏已保存",
    "select_favorite_games": "选择最多5个喜欢的游戏",
    "confirm": "确认",
    "messaging:": "发消息给：",
    "write_message": "输入消息",
    "send": "发送",
    "sort_posts_by": "按以下方式排序帖子：",
    "filter_posts_by_tags": "按标签筛选帖子：",
};

export default zhTranslation;
